export default {"src":"/_next/static/media/KVYO.84b7cbae.svg","height":18,"width":18};